import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl text-center mb-2" }, "関連ツイート", -1)
const _hoisted_2 = { class: "flex flex-wrap justify-center" }
const _hoisted_3 = { class: "flex-1 w-full overflow-y-auto" }
const _hoisted_4 = ["data-height", "href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-sm bg-gray-500 text-white px-4 py-3 my-10 m-auto sm:max-w-full xl:max-w-3/4",
    role: "alert"
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " ※Firefoxのコンテンツブロッキング等が有効な場合はTwitterの埋め込みが正しく表示されない場合があります。 ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.twitter_data, (twitter) => {
        return (_openBlock(), _createElementBlock("div", {
          key: twitter.url
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              "data-height": _ctx.height * 0.75,
              class: "twitter-timeline",
              href: twitter.url
            }, _toDisplayString(twitter.title), 9, _hoisted_4)
          ])
        ]))
      }), 128))
    ]),
    _hoisted_5
  ], 64))
}